import React from 'react';

import NoResults from '../../../../../components/shared/NoResults/index';
import LoadingSpinner from '../../../../../components/shared/LoadingSpinner/index';
import { FullscreenCustomListTitle } from '../../search/fullscreen/custom_list_title';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';
import { PageStrings } from '../../../../../utils/page_strings_util';
import { StringConstantsMixin } from '../shared/string_constants_mixin';
import { SearchFiltersUtil } from '../../../../../utils/search_filters_util';

const ResultCountMixin = {
  handleListTitleUpdate(title, slug) {
    const {
      customList: { id, userId }
    } = this.state;
    this.setState({ customList: { id, userId, title, slug } }, this.replaceHistoryStateAndSearch);
  },
  createH1Obj() {
    let h1Title = this.props.initialTitleString;
    if (!h1Title || h1Title.length < 1) {
      h1Title = StringConstantsMixin.strings.TRAILS;
    }
    let h1Content = h1Title;
    // Special handling for Custom List
    if (this.state.page === PageStrings.EXPLORE_CUSTOM_PAGE && this.state.customList) {
      const canEdit =
        this.props.context.currentUser && (this.props.context.adminUser || this.props.context.currentUser.id === this.state.customList.userId);
      return <FullscreenCustomListTitle list={this.state.customList} canEdit={canEdit} handleListTitleUpdate={this.handleListTitleUpdate} />;
    }
    // User's Recordings/Maps pages
    if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_PAGE || this.state.page === PageStrings.EXPLORE_USERS_MAPS_PAGE) {
      // Set h1Content to have link around user's name in cases like "Andrew's Activities"
      const splitTitleString = h1Title.split(' ');
      if (splitTitleString.length === 2 && this.props.userInfo) {
        h1Content = (
          <span>
            <a
              className="link"
              title={`${this.props.userInfo.firstName} ${this.props.userInfo.lastName}`}
              href={LanguageSupportUtil.wrapUrlSafe(`/members/${this.props.initialUserSlug}`, this.props.context.languageRegionCode)}
            >
              {splitTitleString[0]}
            </a>
            {` ${splitTitleString[1]}`}
          </span>
        );
      } else if (splitTitleString.length === 3 && this.props.userInfo) {
        // "Mapas de Andrew"
        h1Content = (
          <span>
            {`${splitTitleString[0]} ${splitTitleString[1]} `}
            <a
              className="link"
              title={`${this.props.userInfo.firstName} ${this.props.userInfo.lastName}`}
              href={LanguageSupportUtil.wrapUrlSafe(`/members/${this.props.initialUserSlug}`, this.props.context.languageRegionCode)}
            >
              {splitTitleString[2]}
            </a>
          </span>
        );
      }
    }
    // Matching query term
    if (this.state.filters.queryTerm && this.state.filters.queryTerm.length > 0) {
      h1Title = `${h1Title} ${StringConstantsMixin.strings.THAT_MATCH} "${this.state.filters.queryTerm}"`;
      h1Content = h1Title;
    }
    // Selected Location
    else if (this.state.filters.locationObject) {
      // Sometimes h1Title can contain a "near <location>" suffix
      // We need to remove this before adding this again dynamically
      const splitNear = h1Title.split(` ${StringConstantsMixin.strings.NEAR} `);
      if (splitNear.length > 1) {
        h1Title = splitNear[0];
      }
      // Get name/slug from location object
      const obj = this.state.filters.locationObject;
      let { name } = obj;
      if (obj.objectID && obj.objectID.indexOf('city') >= 0) {
        if (obj.state_name) name = `${name}, ${obj.state_name}`;
        if (obj.country_name && obj.country_id !== 313 && obj.country_id !== 139) name = `${name}, ${obj.country_name}`;
      } else if (obj.objectID && obj.objectID.indexOf('state') >= 0) {
        if (obj.country_name && obj.country_id !== 313 && obj.country_id !== 139) name = `${name}, ${obj.country_name}`;
      }
      // Set h1Content
      const newH1Title = `${h1Title} ${StringConstantsMixin.strings.NEAR} ${name}`;
      if (obj.slug) {
        h1Content = (
          <span>
            {`${h1Title} ${StringConstantsMixin.strings.NEAR} `}
            <a className="link" href={LanguageSupportUtil.wrapUrlSafe(`/${obj.slug}`, this.props.context.languageRegionCode)}>
              {name}
            </a>
          </span>
        );
      } else {
        h1Content = newH1Title;
      }
      // Set h1Title
      h1Title = newH1Title;
    }
    // Return if valid content
    if (h1Title && h1Title.length > 0 && h1Content && h1Title !== StringConstantsMixin.strings.TRAILS) {
      return (
        <h1 className={`result-title ${StringConstantsMixin.constants.XLATE.NONE}`} title={h1Title}>
          {h1Content}
        </h1>
      );
    }
    // Always default to what the original
    return null;
  },
  getResultCount() {
    return this.state.results ? this.state.results.length : 0;
  },
  createResultCountObj() {
    const { filters, atMaps, page, isMobileWidth } = this.state;

    if (isMobileWidth && filters.mobileMap) {
      return null;
    }

    // try to intelligently cap the width here if there will be a clear filters button
    const capSpaceForCountObj = SearchFiltersUtil.filtersAreActive(filters);
    const inlineStyle = { display: 'inline-block' };
    if (capSpaceForCountObj) {
      const maxWidth = 298 - (28 + StringConstantsMixin.strings.CLEAR_FILTERS.length * 5);
      inlineStyle.maxWidth = `${maxWidth}px`;
    }

    let titleKey;
    let total;

    if (page === PageStrings.EXPLORE_COMPLETED_PAGE) {
      titleKey = 'SHOWING_TRAIL_OF';
      total = filters.trailIds.length;
    } else if ([PageStrings.EXPLORE_CUSTOM_PAGE, PageStrings.EXPLORE_FAVORITE_PAGE].includes(page)) {
      titleKey = 'SHOWING_ITEM_OF';
      total = filters.trailIds.length + filters.mapIds.length + filters.trackIds.length;
    } else if (page === PageStrings.EXPLORE_USERS_TRACKS_PAGE) {
      titleKey = 'SHOWING_RECORDING_OF';
      total = atMaps ? atMaps.length : 0;
    } else if (page === PageStrings.EXPLORE_USERS_MAPS_PAGE) {
      titleKey = 'SHOWING_MAP_OF';
      total = atMaps ? atMaps.length : 0;
    } else {
      return null;
    }

    if (total == 1) {
      titleKey += '_1';
    }

    const resultCount = this.getResultCount();
    const title = StringConstantsMixin.strings.SEARCH[titleKey].replace('{amount}', resultCount).replace('{total}', total);

    return (
      <span className="result-count" style={inlineStyle}>
        {title}
      </span>
    );
  },
  createLoadingPlaceholder() {
    return (
      <div className="loading-placeholder">
        <LoadingSpinner />
      </div>
    );
  },
  noResultsDiv(header, iconText, iconClass = 'trailpost') {
    return (
      <div id="no-results">
        <div className="header">{header}</div>
        <div className={`icon ${iconClass}`}>
          <span className="icon-text">{iconText}</span>
        </div>
      </div>
    );
  },
  createNoResultsObj() {
    const resultCount = this.getResultCount();

    if ([PageStrings.EXPLORE_ALL_PAGE, PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE].includes(this.state.page)) {
      if (resultCount >= 3) {
        return null;
      }
      if (this.state.loading) {
        return this.createLoadingPlaceholder();
      }
    } else if (resultCount > 0) {
      return null;
    }

    // Initial null state
    let noResultsDiv = this.noResultsDiv(StringConstantsMixin.strings.SEARCH.SEARCH_FOR_TRAILS, StringConstantsMixin.strings.SEARCH.TRAIL_LOAD);
    if ([PageStrings.EXPLORE_ALL_PAGE, PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE].includes(this.state.page)) {
      let stringsPath;
      let tabToPage;
      if (this.state.page === PageStrings.EXPLORE_ALL_PAGE) {
        stringsPath = StringConstantsMixin.strings.SEARCH.NO_RESULTS.CURATED_TRAILS;
        tabToPage = PageStrings.EXPLORE_COMMUNITY_CONTENT_PAGE;
      } else {
        stringsPath = StringConstantsMixin.strings.SEARCH.NO_RESULTS.COMMUNITY_CONTENT;
        tabToPage = PageStrings.EXPLORE_ALL_PAGE;
      }

      const text = {
        title: {
          long: StringConstantsMixin.strings.SEARCH.NO_RESULTS_FOUND,
          short: stringsPath.TITLE.SHORT
        },
        body: {
          long: stringsPath.BODY.LONG,
          short: stringsPath.BODY.SHORT
        }
      };
      noResultsDiv = (
        <NoResults
          className={resultCount < 1 ? 'long' : 'short'}
          text={text.body[resultCount < 1 ? 'long' : 'short']}
          title={text.title[resultCount < 1 ? 'long' : 'short']}
          buttonText={stringsPath.BUTTON}
          handler={this.tabHandler(tabToPage)}
        />
      );
    } else if (this.state.page === PageStrings.EXPLORE_FAVORITE_PAGE) {
      if (!this.state.filters.trailIds || this.state.filters.trailIds.length === 0) {
        noResultsDiv = this.noResultsDiv(this.props.initialNoResultsTitle, StringConstantsMixin.strings.SEARCH.FAVORITE_PROMPT, 'favorite');
      } else if (resultCount === 0) {
        noResultsDiv = this.noResultsDiv(
          StringConstantsMixin.strings.NO_RESULTS,
          StringConstantsMixin.strings.SEARCH.CLEAR_FILTERS_MORE_RESULTS,
          'favorite'
        );
      }
    } else if (this.state.page === PageStrings.EXPLORE_COMPLETED_PAGE) {
      if (!this.state.filters.trailIds || this.state.filters.trailIds.length === 0) {
        noResultsDiv = this.noResultsDiv(this.props.initialNoResultsTitle, StringConstantsMixin.strings.SEARCH.COMPLETION_PROMPT);
      } else if (resultCount === 0) {
        noResultsDiv = this.noResultsDiv(StringConstantsMixin.strings.NO_RESULTS, StringConstantsMixin.strings.SEARCH.CLEAR_FILTERS_MORE_RESULTS);
      }
    } else if (this.state.page === PageStrings.EXPLORE_CUSTOM_PAGE) {
      if (!this.state.filters.trailIds || this.state.filters.trailIds.length === 0) {
        noResultsDiv = this.noResultsDiv(StringConstantsMixin.strings.NO_TRAILS_IN_LIST, StringConstantsMixin.strings.SEARCH.LIST_PROMPT);
      } else if (resultCount === 0) {
        noResultsDiv = this.noResultsDiv(StringConstantsMixin.strings.NO_RESULTS, StringConstantsMixin.strings.SEARCH.CLEAR_FILTERS_MORE_RESULTS);
      }
    } else if (this.state.page === PageStrings.EXPLORE_USERS_TRACKS_PAGE) {
      if (!this.state.atMaps) {
        noResultsDiv = this.noResultsDiv(
          StringConstantsMixin.strings.SEARCH.RECORDING_LOAD_YOUR,
          StringConstantsMixin.strings.SEARCH.RECORDING_LOAD,
          'recordings'
        );
      } else if (this.state.atMaps && this.state.atMaps.length === 0) {
        noResultsDiv = this.noResultsDiv(this.props.initialNoResultsTitle, StringConstantsMixin.strings.SEARCH.RECORDER_PROMPT, 'recordings');
      } else if (resultCount === 0) {
        noResultsDiv = this.noResultsDiv(
          StringConstantsMixin.strings.NO_RECORDINGS,
          StringConstantsMixin.strings.SEARCH.CLEAR_FILTERS_ALL_RECORDINGS,
          'recordings'
        );
      }
    } else if (this.state.page === PageStrings.EXPLORE_USERS_MAPS_PAGE) {
      if (!this.state.atMaps) {
        noResultsDiv = this.noResultsDiv(StringConstantsMixin.strings.SEARCH.MAP_LOAD_YOUR, StringConstantsMixin.strings.SEARCH.MAP_LOAD);
      } else if (this.state.atMaps && this.state.atMaps.length === 0) {
        noResultsDiv = this.noResultsDiv(this.props.initialNoResultsTitle, StringConstantsMixin.strings.SEARCH.PLAN_PROMPT);
      } else if (resultCount === 0) {
        noResultsDiv = this.noResultsDiv(StringConstantsMixin.strings.NO_MAPS, StringConstantsMixin.strings.SEARCH.CLEAR_FILTERS_ALL_MAPS);
      }
    }
    return noResultsDiv;
  },
  createTrailBreadcrumbItems() {
    if (!this.state.selectedObject || this.state.selectedObject.slug == null || this.state.selectedObject.slug == '') return [];
    const breadcrumbItems = [];
    if (this.state.selectedObject.country_id && this.state.selectedObject.country_id != null) {
      const countrySlug = this.state.selectedObject.slug.split('/')[1];
      breadcrumbItems.push({
        link: `/explore/${countrySlug}`,
        label: this.state.selectedObject.country_name,
        class: StringConstantsMixin.constants.XLATE.NONE
      });
    } else {
      return [];
    }
    if (this.state.selectedObject.state_id && this.state.selectedObject.state_id != null) {
      const countrySlug = this.state.selectedObject.slug.split('/')[1];
      const stateSlug = this.state.selectedObject.slug.split('/')[2];
      breadcrumbItems.push({
        link: `/explore/${countrySlug}/${stateSlug}`,
        label: this.state.selectedObject.state_name,
        class: StringConstantsMixin.constants.XLATE.NONE
      });
    }
    if (
      this.state.selectedObject.area_id &&
      this.state.selectedObject.area_id != null &&
      this.state.selectedObject.area_slug &&
      this.state.selectedObject.area_slug != null &&
      this.state.selectedObject.area_slug != ''
    ) {
      const areaSlug = this.state.selectedObject.area_slug;
      const localizedAreaName = LanguageSupportUtil.findRecordFieldWithLocale(
        this.state.selectedObject,
        'area_name',
        this.props.context.languageRegionCode
      );
      breadcrumbItems.push({
        link: `/explore/${areaSlug}`,
        label: localizedAreaName,
        class: StringConstantsMixin.constants.XLATE.NONE
      });
    } else if (
      this.state.selectedObject.city_id &&
      this.state.selectedObject.city_id != null &&
      this.state.selectedObject.city_name &&
      this.state.selectedObject.city_name != ''
    ) {
      const countrySlug = this.state.selectedObject.slug.split('/')[1];
      const stateSlug = this.state.selectedObject.slug.split('/')[2];
      const citySlug = this.state.selectedObject.city_name
        .replace(/\s+/g, '-')
        .replace(/[^a-zA-Z -]/g, '')
        .toLowerCase();
      breadcrumbItems.push({
        link: `/explore/${countrySlug}/${stateSlug}/${citySlug}`,
        label: this.state.selectedObject.city_name,
        class: StringConstantsMixin.constants.XLATE.NONE
      });
    }
    const localizedName = LanguageSupportUtil.findRecordFieldWithLocale(this.state.selectedObject, 'name', this.props.context.languageRegionCode);
    breadcrumbItems.push({ link: null, label: localizedName, class: StringConstantsMixin.constants.XLATE.NONE });
    return breadcrumbItems;
  },
  createMapBreadcrumbItems() {
    if (!this.state.selectedObject) return [];
    // Handle case where the owner of the map is holding-account for maps created by non-logged-in users.
    // The map might not yet have a name or ID if this is the "new map" case.
    if (
      !this.props.context.currentUser &&
      this.state.page === PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE &&
      (!this.props.userInfo || this.props.userInfo.slug == StringConstantsMixin.constants.MAGIC.ANONYMOUS_MAP_USERNAME)
    ) {
      if (!this.state.selectedObject.ID) {
        return [];
      }
      return [{ link: null, label: this.state.selectedObject.name, class: StringConstantsMixin.constants.XLATE.NONE }];
    }
    let user;

    if (this.props.userInfo && this.props.userInfo != null) {
      user = this.props.userInfo;
    } else if (this.state.selectedObject && this.state.selectedObject.user && this.state.selectedObject.user != null) {
      user = this.state.selectedObject.user;
    } else if (this.props.context && this.props.context.currentUser) {
      user = this.props.context.currentUser;
    }
    let userSlug;
    let userFirstName;
    let userLastName;
    if (user) {
      userSlug = user.slug;
      userFirstName = user.firstName || user.first_name || 'User';
      userLastName = user.lastName || user.last_name || 'User';
    }
    const breadcrumbItems = [];
    breadcrumbItems.push({ link: '/members', label: StringConstantsMixin.strings.BREADCRUMB_ITEMS.MEMBERS });
    breadcrumbItems.push({
      link: `/members/${userSlug}`,
      label: `${userFirstName} ${userLastName}`,
      class: StringConstantsMixin.constants.XLATE.NONE
    });

    let addSelectedObjectBreadcrumb = true;

    switch (this.state.page) {
      case PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE:
        breadcrumbItems.push({ link: `/members/${userSlug}/maps`, label: StringConstantsMixin.strings.BREADCRUMB_ITEMS.MAPS });

        // when map creator map is saved, update breadcrumbs with map name
        if (this.state.exploreMap && this.state.exploreMap.name) {
          addSelectedObjectBreadcrumb = false;
          breadcrumbItems.push({ link: null, label: this.state.exploreMap.name });
        }
        break;
      case PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE:
        breadcrumbItems.push({ link: `/members/${userSlug}/recordings`, label: StringConstantsMixin.strings.BREADCRUMB_ITEMS.RECORDINGS });
        break;
      case PageStrings.EXPLORE_LIFELINE_PAGE:
        addSelectedObjectBreadcrumb = false;
        breadcrumbItems.push({ link: null, label: StringConstantsMixin.strings.BREADCRUMB_ITEMS.LIFELINE });
        break;
      default:
        break;
    }

    if (addSelectedObjectBreadcrumb) {
      breadcrumbItems.push({ link: null, label: this.state.selectedObject.name, class: StringConstantsMixin.constants.XLATE.NONE });
    }

    return breadcrumbItems;
  }
};

export { ResultCountMixin };
